module.exports = __webpack_public_path__ + "img/top_img.b7871fa8.jpg";